import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { UseMutationOptions } from "@tanstack/react-query";

import type { DeleteNoteVariables } from "../queryFunctions/deleteProgressNote";
import { deleteProgressNote } from "../queryFunctions/deleteProgressNote";
import { noteKeys } from "../keyFactory";

export function useDeleteNote({
  onSuccess,
  ...options
}: UseMutationOptions<void, unknown, DeleteNoteVariables> = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteProgressNote,
    ...options,
    onSuccess: async (data, variables, context) => {
      queryClient.removeQueries({ queryKey: noteKeys.details(variables.noteId) });
      await queryClient.invalidateQueries({ queryKey: noteKeys.summary(variables.patientId) });
      onSuccess?.(data, variables, context);
    },
  });
}
